import { CalendarHeart, MessageCircle } from "lucide-react";
import { DORIE_URL, WHATSAPP_URL } from "../constants";
import { Reveal } from "./Reveal";

export const Hero = () => (
    <section
        id="home"
        data-testid="hero-section"
        className="relative overflow-hidden scroll-mt-24"
    >
        <video
            data-testid="hero-video-bg"
            className="pointer-events-none absolute inset-0 h-full w-full object-cover"
            autoPlay
            muted
            loop
            playsInline
            src="/hero-video.mp4"
            aria-hidden="true"
        />
        <div
            className="pointer-events-none absolute inset-0 bg-miam-dark/55"
            aria-hidden="true"
        />
        <div
            className="pointer-events-none absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-white to-transparent"
            aria-hidden="true"
        />

        <div className="relative mx-auto flex min-h-[92vh] max-w-7xl flex-col justify-center px-5 pb-24 pt-32 lg:px-10 lg:py-28">
            <div className="grid items-center gap-14 lg:grid-cols-[1.15fr_1fr] lg:gap-20">
                <Reveal>
                    <p
                        data-testid="hero-kicker"
                        className="mb-6 text-sm font-bold uppercase tracking-[0.35em] text-white/80"
                    >
                        ميام · عافية طبيعية
                    </p>
                    <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold leading-[1.3] tracking-tight text-white">
                        ميام – مساحة{" "}
                        <span className="text-[#A9CC6E]">شفاء</span>
                        <span className="mt-3 block italic text-[#D9A4B6]">
                            ووعي
                        </span>
                    </h1>
                    <p className="mt-7 max-w-xl text-base md:text-lg font-medium leading-relaxed text-white/85">
                        حيث يلتقي الجسد بالروح، وتتحوّل اللمسة إلى لغة احتواء
                        وتوازن.
                    </p>
                    <div className="mt-10 flex flex-wrap items-center gap-4">
                        <a
                            href={DORIE_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="hero-booking-button"
                            className="inline-flex items-center gap-2 rounded-full bg-miam-green px-8 py-4 text-base font-bold text-white transition-[transform,background-color,box-shadow] duration-300 hover:-translate-y-1 hover:bg-miam-green-dark hover:shadow-xl"
                        >
                            <CalendarHeart className="h-5 w-5" aria-hidden="true" />
                            احجزي موعدك
                        </a>
                        <a
                            href={WHATSAPP_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="hero-whatsapp-button"
                            className="inline-flex items-center gap-2 rounded-full border-2 border-white/60 px-8 py-[14px] text-base font-bold text-white transition-[transform,background-color,color,border-color] duration-300 hover:-translate-y-1 hover:border-white hover:bg-white hover:text-miam-dark"
                        >
                            <MessageCircle className="h-5 w-5" aria-hidden="true" />
                            اسألي مياسة عبر واتساب
                        </a>
                    </div>
                </Reveal>

                <Reveal delay={0.2} className="mx-auto w-full max-w-sm lg:max-w-none">
                    <div className="relative">
                        <div
                            className="absolute -inset-4 rounded-t-[999px] rounded-b-[2.5rem] bg-white/10 backdrop-blur-[2px]"
                            aria-hidden="true"
                        />
                        <img
                            src="/mayasa.jpg"
                            alt="مياسة، أخصائية الأعشاب والعلاج بالتغذية الطبيعية"
                            data-testid="hero-image"
                            loading="eager"
                            className="relative w-full rounded-t-[999px] rounded-b-[2.5rem] object-cover object-top aspect-[4/5] soft-shadow"
                        />
                        <div className="absolute -bottom-5 -right-3 animate-float-slow rounded-2xl bg-white px-5 py-4 soft-shadow-sm">
                            <p className="font-heading text-sm font-bold text-miam-dark">
                                علاجات طبيعية
                            </p>
                            <p className="text-xs text-miam-muted">
                                بلمسة دافئة واهتمام شخصي
                            </p>
                        </div>
                    </div>
                </Reveal>
            </div>
        </div>
    </section>
);
